import React, { FunctionComponent, useEffect } from 'react';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalAuthenticationResult } from '@azure/msal-react';

import { AppRoutes } from 'Routes';
import { request } from 'auth/authConfig';
import { Fail } from 'components/common/Fail';
import { DeprecationModal } from 'components/common/DeprecationModal';
import { ApiError } from 'services/restService';
import { Layout } from 'components/containers/Layout';
import { commmonStyles } from 'components/commonStyles';
import { AuthContainer } from 'components/containers/AuthContainer';
import './custom.css';
import TranslationsWrapper from 'translations/TranslationsWrapper';
import translationsProvider from 'translations/translationsProvider';
import translationKeys from 'translationKeys';

const App: FunctionComponent = (props) => {
	useEffect(() => {
		initializeIcons();
	}, []);

	return (
		<MsalAuthenticationTemplate
			interactionType={InteractionType.Redirect}
			authenticationRequest={request}
			errorComponent={renderAuthError}
		>
			<AuthContainer>
				<TranslationsWrapper>
					<Layout>
						<>
							<DeprecationModal />
							<AppRoutes />
						</>
					</Layout>
				</TranslationsWrapper>
			</AuthContainer>
		</MsalAuthenticationTemplate>
	);
};

const renderAuthError = ({ error }: MsalAuthenticationResult) => {
	const errorData: ApiError = {
		status: null,
		title: error.name,
		type: error.errorCode,
		detail: error.errorMessage,
		traceId: error.correlationId
	};

	return (
		<Layout>
			<Fail
				error={errorData}
				className={commmonStyles.layoutContainer}
				title={translationsProvider.staticTranslate(translationKeys.App.Fail.Title)}
				detail={translationsProvider.staticTranslate(translationKeys.App.Fail.Detail)}
			/>
		</Layout>
	);
};

export default App;
